import { atom } from "recoil";

const selectedSoundObjecAtom = atom({
  key: "selectedSoundObjecState",
  default: {},
});

export default selectedSoundObjecAtom;
